import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../axiosConfig';
import Modal from '../Components/Modal';
import { motion } from 'framer-motion';
import { renderAsync } from 'docx-preview';
import { hasPermission } from '../Utils/permissions';
import { Link, useNavigate, useLocation } from 'react-router-dom';


function Policies() {
  const [documents, setDocuments] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [customer, setCustomer] = useState('');
  const [documentImages, setDocumentImages] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [currentPolicyId, setCurrentPolicyId] = useState(null);
  const [currentDocumentId, setCurrentDocumentId] = useState(null);
  const [currentUser, setCurrentUser ] = useState(null);
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showImgModal, setShowImgModal] = useState(false);
  const [showUpdateImgModal, setShowUpdateImgModal] = useState(false);
  const [formPolicyData, setFormPolicyData] = useState({
    policy_no: '',
    start_date: '',
    end_date: '',
    premium: '',
    customer: '',
  });
  const [formData, setFormData] = useState({
    id_proof: null,
    address_proof: null,
    pan_card: null,
    salary_slip: null,
    bank_statement: null,
    tax_return: null,
  });
  const [department, setDepartment] = useState('');
  const [ imageId, setImageId ] = useState ('');
  const [currentImageId, setCurrentImageId] = useState(null);
  const [selectedDocumentTypes, setSelectedDocumentTypes] = useState([]);

  const [popupopen, setPopupOpen] = useState (false);
  const [ selectedimage, setSelectedImage] = useState (null);
  const [documentTypes, setDocumentTypes] = useState({});
  const [uploadTypes, setUploadTypes] = useState({});
  const [policyDoc, setAllPolicyDoc] = useState({});
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [selectedPolicyDocumentId, setSelectedPolicyDocumentId] = useState(null);
  const [filteredDocumentTypes, setFilteredDocumentTypes] = useState({});
  const [selectedDepartment, setSelectedDepartment] = useState(localStorage.getItem('selectedDepartment'));
  const [policyFilter, setPolicyFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 18;
  const [previewFile, setPreviewFile] = useState(null);
  const [previewLabel, setPreviewLabel] = useState('');
  const [previewImage, setPreviewImage] = useState(null);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [error, setError] = useState(null);
  const docxContainerRef = useRef(null);
  const [docFiles, setDocFiles] = useState({});
  const [selectedPolicyId, setSelectedPolicyId] = useState(null);
  const [activePath, setActivePath] = useState('');
  const location = useLocation();


  useEffect(() => setActivePath(location.pathname), [location]);
              
  
  const handleImageClick = (image, type) =>{
    setSelectedImage(image);
    setPopupOpen(true);
  }
  
  
  const handleDeleteImage = async (id, imageType) => {
    console.log("Deleting document image");
  
    if (window.confirm("Are you sure you want to delete this image?")) {
      try {
        await axiosInstance.delete(`/upload-documents/${id}/${imageType}/`);
  
        setDocumentImages((prevImages) => 
          prevImages.filter((image) => image.id !== id)
        );
  
        setPopupOpen(false);
        setSelectedImage(null);
      } catch (error) {
        console.error("Error deleting image:", error);
        alert("Failed to delete the image.");
      }
    }
  };
  


  useEffect(() => {
    axiosInstance.get('/documents/')
      .then(response => {
        setDocuments(response.data);
      })
      .catch(error => {
        console.error(error);
      });

      axiosInstance.get('/upload-documents/')
  .then(response => {
    const uploadDocuments = response.data;
    const image = uploadDocuments.find((document) => document.document === currentDocumentId);
    if (image) {
      setImageId(image.id);
    } else {
      setImageId(null);
    }
  })
  .catch(error => {
    console.error(error);
  });

  axiosInstance.get('/policies/')
    .then(response => {
      setPolicies(response.data);
    })
    .catch(error => {
      console.error(error);
    });

    axiosInstance.get('/document-images/')
    .then(response => {
      setUploadTypes(response.data);
    })
    .catch(error => {
      console.error(error);
    });

    axiosInstance.get('/all-policy-doc/')
    .then(response => {
      setAllPolicyDoc(response.data);
    })
    .catch(error => {
      console.error(error);
    });

    const userId = localStorage.getItem('id');
    if (userId) {
      axiosInstance.get(`/user/${userId}/`)
        .then(response => {
          setCurrentUser (response.data);
        })
        .catch(error => {
          console.error("Error fetching user details:", error);
        });
    }
  }, []);

  useEffect(() => {
    if (documentTypes && selectedDepartment) {
      const filteredTypes = Object.keys(documentTypes).filter((key) => {
        return documentTypes[key].department_name === selectedDepartment;
      }).map((key) => documentTypes[key]);
      setFilteredDocumentTypes(filteredTypes);
    }
  }, [documentTypes, selectedDepartment]);

  const handlePolicyChange = (event) => {
    const { name, value } = event.target;
    setFormPolicyData({
      ...formPolicyData,
      [name]: value,
    });
  };

  const handlePolicySubmit = (event) => {
    event.preventDefault();
    
    const formData = new FormData();
    formData.append('policy_no', formPolicyData.policy_no);
    formData.append('start_date', formPolicyData.start_date);
    formData.append('end_date', formPolicyData.end_date);
    formData.append('premium', formPolicyData.premium);
  
    const customerId = localStorage.getItem('selectedCustomerId');
    formData.append('customer', customerId);
  
    axiosInstance.post('/policies/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => {
      setMessage('Document saved successfully!');
      setShowModal(false);
      setFormPolicyData({
        policy_no: '',
        start_date: '',
        end_date: '',
        premium: '',
        customer: '',
      });
      setCurrentPolicyId(response.data.id);
      setShowImgModal(true);
    })
    .catch(error => {
      if (error.response && error.response.data) {
        const errorMessages = Object.entries(error.response.data)
          .map(([key, value]) => Array.isArray(value) ? value.join(', ') : value)
          .join(', ');
        setMessage(errorMessages);
      } else {
        setMessage('An error occurred. Please try again.');
      }
    });
  };
  
  

  const handleChange = (event) => {
    const { name, files } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: files ? files[0] : prevFormData[name],
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  
    const formData = new FormData();
  
    for (const key in docFiles) {
      if (docFiles[key]) {
        formData.append(key, docFiles[key]);
      }
    }
  
    formData.append('policy', currentPolicyId);
    axiosInstance.post('/policy-documents/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => {
      setMessage('Documents uploaded successfully!');
      setShowImgModal(false);
      window.location.reload();
    })
    .catch(error => {
      console.error(error);
      setMessage('Error uploading documents.');
    });
  };
  

  const handleImageUpdate = (event) => {
    event.preventDefault();
  
    const formData = new FormData();
    let added = 0;
  
    document.querySelectorAll('input[type="file"]').forEach((input) => {
      if (input.files.length > 0) {
        formData.append(input.name, input.files[0]);
        added++;
      }
    });
  
    if (added === 0) {
      setMessage('Please select at least one file to update.');
      return;
    }
  
    const policyId = localStorage.getItem('currentPolicyId');
  
    if (!policyId) {
      setMessage('No policy selected for update.');
      return;
    }
  
    axiosInstance.patch(`/policies/${policyId}/documents/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => {
      setMessage('Documents updated successfully!');
      setShowUpdateImgModal(false);
      localStorage.removeItem('currentPolicyId');  // cleanup
      window.location.reload();
    })
    .catch((error) => {
      console.error(error);
      setMessage('Error updating documents.');
    });
  };
  
  
  
  
  
  const openDetailsModal = (policy) => {
    setSelectedPolicy(policy);
    setShowDetailsModal(true);
  
    axiosInstance.get(`/policy-documents/${policy.id}/`)
      .then(response => {
        const documents = response.data[0]; 
  
        if (!documents) {
          setDocumentImages([]);
          return;
        }
  
        const nonFileKeys = ['id', 'policy'];
          const imagesArray = Object.entries(documents)
          .filter(([key, value]) => value && !nonFileKeys.includes(key))
          .map(([key, file]) => ({
            id: key,
            file,
            label: key,
          }));
  
        setDocumentImages(imagesArray);
      })
      .catch(error => {
        console.error("Error fetching document images:", error);
        setDocumentImages([]);
      });
  };
  
  

  const openUpdateModal = (policy) => {
    setFormPolicyData({
      policy_no: policy.policy_no || '',
      start_date: policy.start_date || '',
      end_date: policy.end_date || '',
      premium: policy.premium || '',
      customer: policy.customer || '',
    });
  
    setCurrentPolicyId(policy.id);
    setShowUpdateModal(true);
  };
  
  
  

  const handleUpdatePolicySubmit = (event) => {
    event.preventDefault();
    axiosInstance.put(`/policies/${currentPolicyId}/`, formPolicyData)
      .then(response => {
        setMessage('Policy updated successfully!');
        setShowUpdateModal(false);
        setFormPolicyData({
          policy_no: '',
          start_date: '',
          end_date: '',
          premium: '',
          customer: '',
        });
      })
      .catch(error => {
        setMessage(JSON.stringify(error.response.data));
      });
  };

  const handleDelete = (id) => {
    if (!id) {
      alert("Policy ID is missing!");
      return;
    }
  
    if (window.confirm("Are you sure you want to delete this document?")) {
      axiosInstance.delete(`/policies/${id}/`)
        .then(response => {
          setMessage('Policy Deleted Successfully!');
          window.location.reload();
        })
        .catch(error => {
          const errorData = error?.response?.data || {};
          const errorMessages = Object.keys(errorData).map(key => {
            const value = errorData[key];
            if (Array.isArray(value)) return `${key}: ${value.join(', ')}`;
            if (typeof value === 'string') return `${key}: ${value}`;
            if (typeof value === 'object') return `${key}: ${JSON.stringify(value)}`;
            return `${key}: ${String(value)}`;
          }).join(', ');
          setMessage(errorMessages);
        });
    }
  };

  const handleDownloadImages = () => {
    const policyId = localStorage.getItem('selectedPolicyId');
    if (!policyId) {
      setMessage('No policy selected for download.');
      return;
    }
  
    axiosInstance.get(`/policy-documents/${policyId}/download-all/`, {
      responseType: 'blob',
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `policy_documents_${policyId}.zip`;
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        const errorMessages = Object.keys(error.response.data).map(key => {
          return error.response.data[key].join(', ');
        }).join(', ');
        setMessage(errorMessages);
      } else {
        setMessage('An error occurred. Please try again.');
      }
    });
  };
  
  


  const handleDownloadSingleImage = (docField) => {
    const policyId = localStorage.getItem('selectedPolicyId');
    if (!policyId) {
      setMessage('No policy selected for download.');
      return;
    }
  
    const url = `/policy-documents/${policyId}/download/${docField}/`;
  
    axiosInstance.get(url, { responseType: 'blob' })
      .then(response => {
        const contentType = response.headers['content-type'];
        let fileExtension = 'jpg';
  
        if (contentType === 'application/pdf') fileExtension = 'pdf';
        else if (contentType === 'image/png') fileExtension = 'png';
        else if (contentType === 'image/webp') fileExtension = 'webp';
        else if (contentType === 'image/jpeg') fileExtension = 'jpg';
        else if (contentType === 'application/msword') fileExtension = 'doc';
        else if (contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') fileExtension = 'docx';
  
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `policy_${policyId}_${docField}.${fileExtension}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
  
        setPopupOpen(false);
      })
      .catch(error => {
        setMessage('An error occurred while downloading.');
      });
  };

  const docFields = ['old_policy', 'new_policy', 'quote', 'rc', 'other1', 'other2'];

  
useEffect(() => {
  const customerId = localStorage.getItem('selectedCustomerId');
  const selectedCustomer = localStorage.getItem('selectedCustomer');

  if (customerId && selectedCustomer) {
    setCustomer(selectedCustomer);
    setFormPolicyData(prev => ({
      ...prev,
      selectedCustomer: customerId
    }));
  }
}, []);


useEffect(() => {
  const selectedDepartment = localStorage.getItem('selectedDepartment');
  if (selectedDepartment) {
    setDepartment(selectedDepartment);
  }
}, []);

  useEffect(() => {
    const selectedDocumentTypes = localStorage.getItem('selectedDocumentTypes');
    if (selectedDocumentTypes) {
      setSelectedDocumentTypes(selectedDocumentTypes.split(','));
    }
  }, []);

  const selectedBranch = localStorage.getItem('selectedBranch');

  const fetchDocumentTypes = (branchName) => {
      axiosInstance.get(`/document-types/from-branch/${branchName}/`)
        .then((response) => {
          setUploadTypes(response.data);
        })
        .catch((error) => {
          console.error('Error fetching document types:', error);
          setMessage('Error fetching document types!');
        });
    };

  const isBranchSelected = localStorage.getItem('selectedBranch') !== 'null';  
  const image = documentImages.find(image => image.id === currentImageId);
  const groupByCategory = (documents) => {
    const grouped = {};
    Object.keys(documents).forEach(key => {
      const doc = documents[key];
      const category = doc.category || 'Others';
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(doc);
    });
    return grouped;
  };

const selectedCustomer = localStorage.getItem('selectedCustomer');
const filteredPolicies = policies
  .filter(policy =>
    policy.customer_name === selectedCustomer &&
    policy.policy_no.toLowerCase().includes(policyFilter.toLowerCase())
  )
  .sort((a, b) => {
    const dateA = new Date(a.end_date).getTime();
    const dateB = new Date(b.end_date).getTime();
    return dateA - dateB;
  });


  

  const indexOfLastDocument = currentPage * rowsPerPage;
  const indexOfFirstDocument = indexOfLastDocument - rowsPerPage;
  const currentDocuments = filteredPolicies.slice(indexOfFirstDocument, indexOfLastDocument);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(filteredPolicies.length / rowsPerPage);

const handleFileClick = (file, label) => {
  let fileURL;

  if (file instanceof File || file instanceof Blob) {
    fileURL = URL.createObjectURL(file);
  } else if (typeof file === 'string') {
    // Ensure HTTPS
    const secureFile = file.replace(/^http:\/\//i, 'https://');
    fileURL = secureFile.startsWith('http') ? secureFile : `${process.env.REACT_APP_API_BASE_URL}${secureFile}`;
  } else {
    console.error('Unsupported file type');
    return;
  }

  if (/\.pdf(\?.*)?$/i.test(fileURL)) {
    window.open(fileURL, '_blank');
  } else if (/\.(doc|docx)$/i.test(fileURL)) {
    setPreviewFile(fileURL);
    setPreviewLabel(label);
  } else {
    setPreviewFile(fileURL);
    setPreviewLabel(label);
  }
};

  
  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (files.length === 0) return;
    console.log(`Setting file for ${name}`, files[0]);
    setDocFiles(prev => ({ ...prev, [name]: files[0] }));
  };  
  

  const renderFilePreview = (fileUrl, label, imageId, imageType) => {
    const secureFileUrl = fileUrl?.startsWith('http://')
      ? fileUrl.replace(/^http:\/\//i, 'https://')
      : `${process.env.REACT_APP_API_BASE_URL}${fileUrl}`;
  
    const isImage = /\.(jpg|jpeg|png|webp|gif)$/i.test(secureFileUrl);
    const isPDF = /\.pdf(\?.*)?$/i.test(secureFileUrl); 
    const isDoc = /\.(doc|docx)$/i.test(secureFileUrl);
  
    return (
      <div key={label + imageId} style={{ textAlign: 'center', margin: '5px' }}>
        {isImage ? (
          <img
            src={secureFileUrl}
            alt={label}
            style={{ width: '60px', height: '60px', cursor: 'pointer' }}
            onClick={() => handleImageClick({ id: imageId, url: secureFileUrl, imageType })}
          />
        ) : isPDF ? (
          <div
            style={{
              fontSize: '40px',
              color: 'red',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={() => handleImageClick({ id: imageId, url: secureFileUrl, imageType })}
          >
            <i className="fas fa-file-pdf"></i>
          </div>
        ) : isDoc ? (
          <div
            style={{
              fontSize: '40px',
              color: 'blue',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={() => handleImageClick({ id: imageId, url: secureFileUrl, imageType })}
          >
            <i className="fas fa-file-word"></i>
          </div>
        ) : (
          <div
            style={{
              fontSize: '16px',
              color: 'gray',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={() => handleImageClick({ id: imageId, url: secureFileUrl, imageType })}
          >
            <i className="fas fa-file-alt"></i>
            <div style={{ fontSize: '12px', color: '#666' }}>Unknown File</div>
          </div>
        )}
      </div>
    );
  };
  

  useEffect(() => {
    const loadDocx = async () => {
      if (previewFile && /\.(docx?)$/i.test(previewFile) && docxContainerRef.current) {
        try {
          let secureUrl = previewFile;
          if (secureUrl.startsWith('http://')) {
            secureUrl = secureUrl.replace('http://', 'https://');
          }
  
          const response = await fetch(secureUrl);
          const blob = await response.blob();
          docxContainerRef.current.innerHTML = ""; 
          await renderAsync(blob, docxContainerRef.current);
        } catch (error) {
          console.error("Error rendering DOCX:", error);
        }
      }
    };
  
    loadDocx();
  }, [previewFile]);
  

  const handleIconClick = (policyId) => {
    localStorage.setItem('selectedPolicyId', policyId);
  };

  const verificationStatus = localStorage.getItem('verification_status');

  const handleDownloadPDF = async () => {
    const selectedDocumentId = localStorage.getItem('selectedDocumentId');
    if (!selectedDocumentId) {
      setError('No document selected. Please select a document to download.');
      return;
    }
    setDownloadingPdf(true);
    try {
      const response = await axiosInstance.get(`/documents/download/${selectedDocumentId}/`, {
        responseType: 'blob',
      });
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank');
      setDownloadingPdf(false);
    } catch (error) {
      setError('Failed to download PDF. Please try again.');
      console.error('Error downloading PDF:', error);
      setDownloadingPdf(false);
    }
  };

  const toProperCase = (str) => {
    return str
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };
  
  
  return (
   
             <div className="dashboard-wrapper">
                       {/* Left Sidebar */}
                       <div className="dashboard-sidebar">
               <div className="sidebar-header">
                 <img src="/logo.png" alt="Logo" className="sidebar-logo" />
               </div>
             
               <nav className="sidebar-nav">
                 <Link
                   to="/admin-dashboard"
                   className={`sidebar-link ${activePath === '/admin-dashboard' ? 'active' : ''}`}
                 >
                   <i className="fas fa-home"></i> Dashboard
                 </Link>
             
                 {currentUser?.role_name === 'admin' && (
                   <Link
                     to="/users"
                     className={`sidebar-link ${activePath === '/users' ? 'active' : ''}`}
                   >
                     <i className="fas fa-users"></i> Users
                   </Link>
                 )}
             
                 {/* Simplified Departments Link */}
                 <Link
                   to="/departments"
                   className={`sidebar-link ${activePath === '/departments' ? 'active' : ''}`}
                 >
                   <i className="fas fa-file-alt"></i> Departments
                 </Link>
               </nav>
             </div>
             <div
                  className="dashboard-main"
                  style={{
                    display: 'flex',
                    gap: '20px',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: '20px',
                  }}
                >
                   <div className="dashboard-content" style={{ flex: 3 }}>
                  
                  <h2>Policies</h2>
                  <div className="dashboard-cards"
                                      style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}
                                    >
                                       <motion.div className="dashboard-card">
                                                    <div className="card-header">
                                                    {currentUser &&
                    (['admin', 'subadmin'].includes(currentUser.role_name) || hasPermission('Department Create')) && (
                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', cursor: 'pointer' }}>
                      <button
                    className="view-all-btn"
                    title="Add Department"
                    onClick={() => setShowModal(true)}
                  >
                    <span>+ Add Policy</span>
                  </button>
                  
                      </div>
                  )}
                                                    </div>
                                                  </motion.div>
             
<Modal isOpen={showModal} onClose={() => setShowModal(false)}>
  <form onSubmit={handlePolicySubmit}>
    <div className='doc'> 
        <h2>Add Policy 
             <span>Add Policy related to specific department.</span>
        </h2>
        </div>  
    <hr />
    <div className="form-row1">
    <div className='form-group'>
        <label className='user-label'>Policy Number*</label>
        <input type="text" name="policy_no" value={formPolicyData.policy_no} onChange={handlePolicyChange} required />
      </div>
      <div className='form-group'>
            <label>Start Date*</label>
            <input type="date" name="start_date" value={formPolicyData.start_date} onChange={handlePolicyChange} required />
        </div>
        <div className='form-group'>
            <label>End Date*</label>
            <input type="date" name="end_date" value={formPolicyData.end_date} onChange={handlePolicyChange} required />
        </div>
    
    <div className='form-group'>
        <label>Premium</label>
        <input type="text" name="premium" value={formPolicyData.premium} onChange={handlePolicyChange} required />
      </div>
      <div className='form-group'>
        <label>Customer</label>
        <input type="text" name="customer" value={customer} disabled />
      </div>
  </div>

    <hr />
    <button className='submit-all-btn' type="submit">Add Policy</button>
  </form>
  {message &&  <p style={{ color: 'red' }}>{message}</p>}
</Modal>

<Modal isOpen={showUpdateModal} onClose={() => setShowUpdateModal(false)}>
  <form onSubmit={handleUpdatePolicySubmit}>
    <div className='doc'> 
      <h2>Update Policy
        <span>Update Policy details.</span>
      </h2>
    </div>  
    <hr />
    <div className="form-row1">
    <div className='form-group'>
        <label className='user-label'>Policy Number*</label>
        <input type="text" name="policy_no" value={formPolicyData.policy_no} onChange={handlePolicyChange} />
      </div>
      <div className='form-group'>
            <label>Start Date*</label>
            <input type="date" name="start_date" value={formPolicyData.start_date} onChange={handlePolicyChange} />
        </div>
        <div className='form-group'>
            <label>End Date*</label>
            <input type="date" name="end_date" value={formPolicyData.end_date} onChange={handlePolicyChange} />
        </div>
    
    <div className='form-group'>
        <label>Premium</label>
        <input type="text" name="premium" value={formPolicyData.premium} onChange={handlePolicyChange} />
      </div>
      <div className='form-group'>
        <label>Customer</label>
        <input type="text" name="customer" value={customer} disabled />
      </div>
  </div>
    <hr />
    <button className='submit-all-btn' type="submit">Update</button>
  </form>
  {message &&  <p style={{ color: 'red' }}>{message}</p>}
</Modal>

<Modal
  isOpen={showImgModal}
  onClose={(event) => {
    event.preventDefault();
    setShowImgModal(false);
    window.location.reload();
  }}
>
  <form onSubmit={handleSubmit} encType="multipart/form-data">
    <div className='doc'>
      <h2>
        Upload Policy Documents
        <span>Upload files related to the selected policy.</span>
      </h2>
    </div>
    <hr />

    <div className="form-row1">
      <div className="form-group">
        <label>Old Policy</label>
        <input type="file" name="old_policy" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>New Policy</label>
        <input type="file" name="new_policy" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Quote</label>
        <input type="file" name="quote" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>RC</label>
        <input type="file" name="rc" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Other Document 1</label>
        <input type="file" name="other1" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Other Document 2</label>
        <input type="file" name="other2" onChange={handleFileChange} />
      </div>
    </div>

    <button type="submit">Upload Documents</button>
  </form>
  {message && <p style={{ color: 'red' }}>{message}</p>}
</Modal>




<Modal isOpen={showUpdateImgModal} onClose={() => setShowUpdateImgModal(false)}>
  <form onSubmit={handleImageUpdate} encType="multipart/form-data">
    <div className='doc'>
      <h2>
        Update Policy Documents
        <span>Update files related to the selected policy.</span>
      </h2>
    </div>
    <hr />

    <div className="form-row1">
      <div className="form-group">
        <label>Old Policy</label>
        <input type="file" name="old_policy" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>New Policy</label>
        <input type="file" name="new_policy" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Quote</label>
        <input type="file" name="quote" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>RC</label>
        <input type="file" name="rc" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Other Document 1</label>
        <input type="file" name="other1" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Other Document 2</label>
        <input type="file" name="other2" onChange={handleFileChange} />
      </div>
    </div>

    <button className='submit-all-btn' type="submit">Update Documents</button>
  </form>
  {message && <p style={{ color: 'red' }}>{message}</p>}
</Modal>

<Modal isOpen={showDetailsModal} onClose={() => setShowDetailsModal(false)}>
  {selectedPolicy && (
    <div>
      <div className='doc'>
        <h1>Policy Details
          <span>Details related to specific policy.</span>
        </h1>
      </div>
      <hr />

      <div className="document-info-grid">
        <div className="grid-doc">
          <p><strong>Policy Number:</strong> {selectedPolicy.policy_no}</p>
        </div>
        <div className="grid-doc">
          <p><strong>Start Date:</strong> {selectedPolicy.start_date}</p>
        </div>
        <div className="grid-doc">
          <p><strong>End Date:</strong> {selectedPolicy.end_date}</p>
        </div>
        <div className="grid-doc">
          <p><strong>Premium:</strong> {selectedPolicy.premium}</p>
        </div>
        <div className="grid-doc">
          <p><strong>Customer:</strong> {selectedPolicy.customer_name}</p>
        </div>
      </div>

      <hr />
      

      {documentImages.length > 0 ? (
  <div className="form-row-inline">
    {documentImages.map((image) => {
      const url = image.file; // full URL
      const ext = url.split('.').pop().toLowerCase();

      const label = toProperCase(image.label);

      let preview;
      if (ext === 'pdf') {
        preview = (
          <div
            className="doc-icon"
            style={{ fontSize: '30px', color: 'red', cursor: 'pointer' }}
            title="Click to open PDF"
            onClick={() => window.open(url, '_blank')}
          >
            <i className="fas fa-file-pdf"></i>
          </div>
        );
      } else if (ext === 'doc' || ext === 'docx') {
        preview = (
          <div
            className="doc-icon"
            style={{ fontSize: '30px', color: '#2A5699', cursor: 'pointer' }}
            title="Click to open DOC"
            onClick={() => window.open(url, '_blank')}
          >
            <i className="fas fa-file-word"></i>
          </div>
        );
      } else if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext)) {
        preview = (
          <img
            src={url}
            alt={`${label} document`}
            className="doc-image"
            style={{ cursor: 'pointer', maxWidth: '100px' }}
            onClick={() => {
              handleFileClick(url, label);
              setPreviewImage({ ...image, file: url });
            }}
          />
        );
      } else {
        preview = (
          <div
            className="doc-icon"
            style={{ fontSize: '30px', color: '#555', cursor: 'pointer' }}
            title="Click to open file"
            onClick={() => window.open(url, '_blank')}
          >
            <i className="fas fa-file"></i>
          </div>
        );
      }

      return (
        <div key={image.id} className="form-inline-item">
          <label style={{ fontSize: '12px', marginLeft: '0px' }}>{label}:</label>
          <div
            className="doc-preview"
            onClick={() => {
              handleFileClick(image.file, label);
              setPreviewImage(image);
            }}
            style={{ cursor: 'pointer' }}
          >
            {renderFilePreview(image.file, label, image.id, image.parsedName)}
          </div>
        </div>
      );
    })}
  </div>
) : (
  <p>No images found for this document.</p>
)}
<button
  type='button'
  title="Download All"
  onClick={handleDownloadImages}
  style={{
    cursor: 'pointer',
    fontSize: '15px',
    color: '#fff',
    backgroundColor: '#000',
    border: '1px solid #ccc',
    borderRadius: '6px',
    padding: '5px 10px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
  }}
  onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#fff')}
  onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#000')}
>
  Download All
</button>
                </div>
            )}
</Modal>

<div>
      <div style={{ marginBottom: '10px', textAlign: 'left' }}>
        <input
          type="text"
          placeholder="Filter by Policy Number"
          value={policyFilter}
          onChange={(e) => setPolicyFilter(e.target.value)}
          style={{
            padding: '3px 10px',
            fontSize: '14px',
            width: '250px',
            borderRadius: '5px',
            border: '1px solid #000',
            marginBottom: '0px',
            display: 'inline-block'
          }}
        />
      </div>

      <table className="striped-table">
  <thead>
    <tr>
      <th className='doc-table'>Policy Number</th>
      <th className='doc-name'>Start Date</th>
      <th>End Date</th>
      <th>Premium</th>
      <th>Customer</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
  {filteredPolicies.map((policy, index) => (
    <tr key={index}>
      <td>{policy.policy_no}</td>
      <td>{new Date(policy.start_date).toLocaleDateString('en-GB')}</td>
      <td>{new Date(policy.end_date).toLocaleDateString('en-GB')}</td>
      <td>{policy.premium}</td>
      <td>{policy.customer_name}</td>
      <td>
      <>
  {(hasPermission("Update Policy Doc") || (currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' ))) && (
    <i
      className="fas fa-edit"
      title="Update"
      onClick={() => {
        handleIconClick(policy.id);
        openUpdateModal(policy);
      }}
      style={{ cursor: 'pointer', marginRight: '10px' }}
    ></i>
  )}

  {(hasPermission("View Policy") || (currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' ))) && (
    <i
      className="fas fa-eye"
      title="View"
      onClick={() => {
        handleIconClick(policy.id);
        openDetailsModal(policy);
      }}
      style={{ cursor: 'pointer', marginRight: '10px' }}
    ></i>
  )}

  {(hasPermission("Delete Policy") || (currentUser && currentUser.role_name === 'admin')) && (
    <i
      className="fas fa-trash"
      title="Delete"
      onClick={() => {
        handleIconClick(policy.id);
        handleDelete(policy.id);
      }}
      style={{ cursor: 'pointer', marginRight: '10px' }}
    ></i>
  )}

  {(hasPermission("Update Policy Doc") || (currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' ))) && (
    <i
      className="fas fa-upload"
      title="Upload Documents"
      onClick={() => {
        handleIconClick(policy.id);
        localStorage.setItem('currentPolicyId', policy.id);
        setSelectedPolicyDocumentId(policy.id);
        setShowUpdateImgModal(true);
      }}
      style={{ cursor: 'pointer', marginRight: '10px' }}
    ></i>
  )}
</>

</td>
    </tr>
  ))}
</tbody>
</table>


      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              padding: '0px 10px',
              margin: '0 5px',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              backgroundColor: '#ddd',
              border: 'none',
              borderRadius: '5px',
              fontSize: '12px'
            }}
          >
            Previous
          </button>
          <span style={{ padding: '3px 12px', fontSize: '12px' }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              padding: '0px 10px',
              margin: '0 5px',
              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
              backgroundColor: '#ddd',
              border: 'none',
              borderRadius: '5px',
              fontSize: '12px'
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>


    {previewFile && (
  <div className="modal-overlay" onClick={() => setPreviewFile(null)}>
    <div className="preview-modal-content" onClick={(e) => e.stopPropagation()}>
    <div className="popup-header">
              <span className="close-icon"onClick={() => setPreviewFile(null)}>
                ×
              </span>
            </div>
      <h4>{previewLabel}</h4>

      {/\.(pdf)$/i.test(previewFile) ? (
  <iframe
    src={previewFile}
    width="100%"
    height="500px"
    title="PDF Viewer"
    frameBorder="0"
  />
) : /\.(docx?)$/i.test(previewFile) ? (
  <div
    ref={docxContainerRef}
    style={{
      maxHeight: '500px',
      overflow: 'auto',
      border: '1px solid #ccc',
      padding: '10px',
    }}
  />
) : (
  <img
    src={previewFile}
    alt={previewLabel}
    style={{ maxWidth: '100%', maxHeight: '400px' }}
  />
)}


      {previewImage && (
  <button
    className="download-button"
    onClick={() =>
      handleDownloadSingleImage(previewImage.id, previewImage.document_type?.name)
    }
  >
    Download
  </button>
)}
    </div>
  </div>
)}
</div>
</div>
</div>
</div>
  );
}

export default Policies;